import { Link } from 'react-router-dom';
import Logo from '@/shared/components/modules/Logo.jsx';
import logo from '@/assets/images/WhiteLogo.png';
import shovel from '@/assets/images/Shovel.png';

export default function UnderConstructionPage() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-white">
      {/* Header */}
      <header className="bg-secondary-100 flex w-full shrink-0 items-center justify-center px-5 py-6 md:px-20 md:py-8">
        <Logo
          src={logo}
          alt="لوگوی اینتلیو"
          size="md"
          className="w-[134px] shrink-0"
        />
      </header>

      {/* Main Content */}
      <main className="flex flex-1 flex-col items-center justify-center px-5 py-8 md:px-20">
        {/* Desktop Layout */}
        <div className="hidden w-full max-w-[1400px] flex-row items-center justify-center gap-60 md:flex">
          {/* Text Content and Button */}
          <div className="flex flex-col items-center gap-12 text-center">
            <div className="text-tertiary-100 flex flex-col gap-3">
              <h1 className="text-6xl font-black">یکم دیگه مونده...</h1>
              <p className="text-[32px] font-extrabold">
                صفحه مورد نظر شما در دست توسعه است
              </p>
            </div>

            {/* Back Button */}
            <Link
              to="/"
              className="border-primary-100 hover:bg-primary-100 group flex items-center gap-2.5 rounded-full border-2 px-8 py-6 transition-all duration-300"
            >
              <span className="text-primary-100 text-[32px] font-extrabold whitespace-nowrap transition-colors group-hover:text-white">
                بازگشت به صفحه اصلی
              </span>
              <i className="fi fi-rr-arrow-left text-primary-100 flex items-center justify-center text-[32px] transition-all duration-300 group-hover:-translate-x-2 group-hover:text-white"></i>
            </Link>
          </div>

          {/* Construction Illustration */}
          <div className="relative h-[370px] w-[370px]">
            <img
              src={shovel}
              alt="صفحه در دست توسعه است"
              className="h-full w-full object-contain"
              loading="lazy"
            />
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="flex w-full flex-col items-center justify-center gap-8 md:hidden">
          {/* Text Content */}
          <div className="text-tertiary-100 flex flex-col items-center gap-2 text-center">
            <h1 className="text-[40px] font-black">یکم دیگه مونده...</h1>
            <p className="text-xl font-bold">
              صفحه مورد نظر شما در دست توسعه است
            </p>
          </div>

          {/* Construction Illustration */}
          <div className="relative h-[280px] w-[280px]">
            <img
              src={shovel}
              alt="صفحه در دست توسعه است"
              className="h-full w-full object-contain"
              loading="lazy"
            />
          </div>

          {/* Back Button */}
          <Link
            to="/"
            className="border-primary-100 hover:bg-primary-100 group flex items-center gap-2 rounded-full border-2 px-5 py-4 transition-all duration-300"
          >
            <span className="text-primary-100 text-xl font-bold whitespace-nowrap transition-colors group-hover:text-white">
              بازگشت به صفحه اصلی
            </span>
            <i className="fi fi-rr-arrow-left text-primary-100 flex items-center justify-center text-xl transition-all duration-300 group-hover:-translate-x-1 group-hover:text-white"></i>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-secondary-100 mt-auto flex w-full shrink-0 items-center justify-center px-5 py-6 md:px-20 md:py-8">
        <p className="text-center text-sm text-white md:text-base">
          تمامی حقوق این وبسایت متعلق به برسام داده پرداز البرز می‌باشد
        </p>
      </footer>
    </div>
  );
}
